<template>
  <div>
    <div
      v-if="!isShowShareRecipientList"
      class="relative"
    >
      <section class="share__presentation-online-link">
        <h3 class="flex items-center my-2" v-if="!hideTitle">
          <aha-icon-container
            class="my-2 mr-2 font-bold truncate cursor-pointer"
            size="md"
            icon-class="bg-secondary-40 text-base-0"
          >
            <aha-icon
              name="duplicated"
              width="14"
              height="14"
              viewBox="0 0 18 18"
            />
          </aha-icon-container>
          Share a copy
        </h3>
        <p class="share__section-description">
          Anyone with this link can view this presentation
          and copy it (without audience responses)
          to their own account.
        </p>

        <aha-clipboard
          class="text-xs"
          :clipboard="() => {
            return getShareLink()
          }"
          :source="'share-a-copy'"
          @copy="copyLink('share-slide')"
        />

        <p
          class="mt-2 text-xs"
          v-if="presentation.copyCount"
        >
          This presentation has been copied {{ presentation.copyCount }} time(s).
        </p>

        <CheckboxCopySlideNote
          :presentation="presentation"
          class="mt-3"
        />

        <CheckboxAudienceRequestPresentation
          :presentation="presentation"
          class="mt-3"
          v-if="!isWhiteLabel && currentUser.identifyProvider !== 'skoletube' &&
            presentation.showAhaSlidesCTA && !currentUser.isGuest"
        />
      </section>

      <div v-if="sendACopyVisible" class="pt-3 border-t border-base-30">
        <section class="pb-2">
          <p class="mb-2 text-xs">
            Send a copy of this presentation (with audience responses) to your team members.
          </p>
          <a
            @click="handleShowSendACopyDialog()"
            class="font-bold text-link--primary btn-send-to"
          >
            Send to...
          </a>
        </section>
      </div>
    </div>
    <div v-if="isShowShareRecipientList">
      <div
        class="sticky top-0 z-10 flex items-center justify-center shadow-top bg-base-0 border-base-30 h-15 text-base-90"
      >
        <span
          @click="handleBackButtonClick()"
          class="absolute cursor-pointer left-4"
        >
          <aha-icon name="arrow-left" />
        </span>
        <p class="text-sm font-bold text-secondary-100 send-copy-modal-title">
          Send a copy to your team members
        </p>
      </div>
      <recipients-list
        class="px-4 pt-4 pb-16"
        :presentation="$store.state.presentation"
        v-if="isShowShareRecipientList"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Config from '@/config'
import Utils from '@/util'
import constants from '@/constant'
// components
import RecipientsList from '@/components-v2/modals/RecipientsList.vue'
import CheckboxCopySlideNote from '@/components-v2/presentation-editor/collaboration/CheckboxCopySlideNote.vue'
import CheckboxAudienceRequestPresentation from '@/components-v2/presentation-editor/collaboration/CheckboxAudienceRequestPresentation.vue'

export default {
  components: {
    RecipientsList,
    CheckboxCopySlideNote,
    CheckboxAudienceRequestPresentation,
  },
  props: {
    presentation: {
      type: Object,
      required: false,
      default() {
        return null
      },
    },
    hasPadding: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTeamSetup: false,
      openChangeAccessCode: false,
      submitting: false,
      newAccessCode: '',
      textError: '',
      domain: '',
      presenterLink: '',
      isShowShareRecipientList: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    sendACopyVisible() {
      if (this.currentUser.accountRole === 'viewer' && this.$store.state.workingMode === constants.workspace.TEAM) return false
      return this.currentUser.identifyProvider !== 'skoletube' && this.currentUser.accountId
    },
    isWhiteLabel() {
      return Utils.checkWhiteLabelDomain()
    },
  },
  mounted() {
    this.domain = Config.domain
    this.presenterLink = window.location.origin
    this.newAccessCode = (this.presentation && this.presentation.accessCode)
    || this.$store.state.presentation.accessCode

    if ((this.presentation && this.presentation.whiteLabelLink)
    || this.$store.state.presentation.whiteLabelLink) {
      if (this.presentation && this.presentation.whiteLabelLink) {
        this.domain = this.presentation.whiteLabelLink
      } else {
        this.domain = this.$store.state.presentation.whiteLabelLink
      }
    }
  },
  methods: {
    ...mapActions(['patchPresentationAction']),
    getShareLink() {
      const { slugifiedName: slug, shareCode } = this.presentation
      if (slug && shareCode && shareCode.indexOf('-') > -1) {
        return `${this.presenterLink}/share/${slug}-${shareCode}`
      }
      return `${this.presenterLink}/share/${shareCode}`
    },
    handleBackButtonClick() {
      this.isShowShareRecipientList = false
      this.$emit('handle-hide-main-header')
    },
    copyLink() {
      Utils.showToastSuccess('Link copied!')
    },

    handleShowSendACopyDialog() {
      const route = this.$route.name
      if (route === 'PresentationDetail') {
        this.isShowShareRecipientList = true
        this.$emit('handle-hide-main-header')
      } else if (route === 'Presentations' || route === 'FolderDetail') {
        this.$emit('handleShowSendACopyDialog')
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.share__section-title {
  @apply mb-3 text-sm font-bold text-secondary-100;
}

.share__section-description {
  @apply mb-3 text-xs;
}
.share__presentation-online-link {
  @apply mb-3;
}

</style>
